<!--
  ~ Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->
<div class="og-container">
  @if (isLoading) {
  <div class="container__spinner">
    <mat-progress-spinner
      [mode]="'indeterminate'"
      [color]="'accent'"
      [diameter]="60"
    ></mat-progress-spinner>
  </div>
  } @else {
  <mat-selection-list
    class="value__list"
    [disabled]="!isEditable"
    (selectionChange)="onSelectionListChange($event)"
  >
    <!-- Expected values -->
    @for (namedValue of allowedValues; track namedValue) {
    <mat-list-option
      checkboxPosition="before"
      [selected]="list.updated.includes(namedValue.value)"
      [matTooltip]="namedValue.value"
      [matTooltipShowDelay]="2000"
      [value]="namedValue.value"
    >
      {{ namedValue.name }}
    </mat-list-option>
    }
  </mat-selection-list>
  @if (filterUnexpectedValues(); as unexpectedValues) { @if (unexpectedValues.length > 0) {
  <mat-card appearance="outlined" class="unexpected-values__card">
    <mat-card-header>
      <mat-card-title>Warning</mat-card-title>
      <mat-card-subtitle>
        The values below are not allowed @if (isEditable) {
        <span>and will be deleted</span>
        }
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <mat-list class="value__list">
        <!-- Unexpected values -->
        @for (unexpectedValue of unexpectedValues; track unexpectedValue) {
        <mat-list-item class="disallowed-value__list-option">
          {{ unexpectedValue }}
        </mat-list-item>
        }
      </mat-list>
    </mat-card-content>
  </mat-card>
  } } }
</div>
